import React, { useState, useEffect } from "react";
import store from "@/redux/store";
import {getInvoiceAPIState, invoiceInit, resetState} from "@/reducers/Invoice";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { EyeIcon } from '@heroicons/react/24/outline';

import Drawer from "@/controllers/Drawer";
import {createInvoice, newInvoiceModel} from "@/reducers/Invoice";
import { loadCustomer, addCustomer, unsetSelected } from '@/reducers/Customer'
import {showConfirmModal, hideModal, showInvoiceAddRow} from "@/reducers/ModalPopup";
import { SelectBox } from "@/components/holders/SelectBox";
import { InvoiceRow } from "@/models/InvoiceRow";

import {
  Bars3Icon,
  CalendarDaysIcon,
  CreditCardIcon,
  EllipsisVerticalIcon,
  FaceFrownIcon,
  FaceSmileIcon,
  FireIcon,
  HandThumbUpIcon,
  HeartIcon,
  PaperClipIcon,
  UserCircleIcon,
  XMarkIcon as XMarkIconMini,
  PencilIcon
} from '@heroicons/react/20/solid'
import { BellIcon, XMarkIcon as XMarkIconOutline } from '@heroicons/react/24/outline'
import { CheckCircleIcon } from '@heroicons/react/24/solid'
import { PlusIcon } from '@heroicons/react/20/solid'
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react'
import { InvoiceRowModel } from "@/models/Invoice";

export function Create({...props}) {
    const [selectedData, setSelectedData] = useState(null);
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const navigate = useNavigate();
    
    const [invoice, setInvoice] = useState(props?.invoice);

   const setValueCombobox= (name, selected) => {
    if(selectedCustomer != selected) {
        store.dispatch(newInvoiceModel({customer: selected}));
        setSelectedCustomer(selected);
    }
   }


const invoiceTotals = {


  subTotal: '0.00',
  tax: '0.00',
  total: '0.00',
  items: [
   
  ],
}

const editInvoiceRow = (item) => {
    
    store.dispatch(showInvoiceAddRow({vatrates: props.InvoiceReducer.vatrates, worktypes: props.InvoiceReducer.workTypes, customer:selectedCustomer, action:replaceInvoiceRow, invoiceRow: item, mode:'edit'}));
    return false;
}

const addNewInvoiceRow = (event) => {
    event.preventDefault();
    store.dispatch(showInvoiceAddRow({vatrates: props.InvoiceReducer.vatrates, worktypes: props.InvoiceReducer.workTypes, customer:selectedCustomer, action:addInvoiceRow, mode:'new'}));
    return false;
}

const replaceInvoiceRow =(invoiceRowData, extraData=null) => {
    invoice.replaceRow(invoiceRowData);
    store.dispatch( hideModal() );
};

const addInvoiceRow =(invoiceRowData, extraData=null) => {
    if(invoiceRowData && invoiceRowData instanceof InvoiceRow && invoiceRowData.validate) {
        invoiceRowData.calculate();
    }    
    let invoiceRow = null;
    if(invoiceRowData.invoice_type == 3) {
//        invoiceRow = new InvoiceRow(invoiceRowData);    
//        let ivr = new InvoiceRowModel(invoiceRowData);
        invoice.addRow(invoiceRowData);
    } else {
//        invoiceRow = new InvoiceRow(invoiceRowData);    
//        let ivr = new InvoiceRowModel(invoiceRowData);
//        invoice.addRow(ivr);
        invoice.addRow(invoiceRowData);
    }
    
    
//    setInvoiceRows([...invoiceRows, invoiceRow]);
    
    store.dispatch( hideModal() );
}
const showPreview = (event, item) => {
    event.preventDefault();
    store.dispatch(loadCustomer(item.key));
    setSelectedData({data: item, click: new Date()});
    
    return false;
  }

const removeHandler = (event, item) => {
    event.preventDefault();
    
    store.dispatch(showConfirmModal({item: item, action: confirmedRemoveHandler}));
    
    return false;
  }
const confirmedRemoveHandler = (props) => {
    store.dispatch(removeCustomer(props.item.key));
    store.dispatch(hideModal());
}

const createInvoiceHandler = () => {
    store.dispatch(createInvoice(invoice.getData()));
    store.dispatch(hideModal());
    navigate("/invoices");
}

useEffect(() => {
    if(invoice && invoice.customer) {
        setSelectedCustomer(invoice.customer);
    }
    return () => {
            //props.updateInvoiceRowHandler(props.invoiceRow);
    };
  }, [invoice]);




  return (
    <>
    {props.data && props.data.from && props.data.from.name && invoice && invoice.rows &&
    <div className="px-4 sm:px-6 lg:px-8">
     
     
      <main>

        <div className="mx-auto max-w-7xl ">
          <div className="mx-auto grid max-w-2xl grid-cols-1 grid-rows-1 items-start gap-x-8 gap-y-8 lg:mx-0 lg:max-w-none lg:grid-cols-3">
          
          
          
            {/* Invoice summary */}
            <div className="lg:col-start-3 lg:row-end-1">
              <div className="rounded-lg bg-gray-50 shadow-sm ring-1 ring-gray-900/5">
                <dl className="">
                  <div className=" block w-full">
                  <dt className="font-semibold text-gray-900 px-4 pt-4">
                        <SelectBox className="" label="" name="customer" data={props.data.customers} boxfield="name" selected={selectedCustomer} placeHolder="Selecteer een klant" changeEvent={(name, val) => setValueCombobox(name,val)}/>
                  </dt>
                  </div>
                  <div className=" block w-full">
                  <dt className="font-semibold text-gray-900 px-4 pt-4">
      <button
        disabled={(!selectedCustomer)}
        onClick={() => addNewInvoiceRow(event)}
        type="button"
        className={"inline-flex items-center gap-x-1.5 rounded-md bg-indigo-600 px-2.5 py-1.5 text-sm font-semibold text-white shadow-sm w-full "+ ((!selectedCustomer) ? "cursor-not-allowed opacity-50" : "hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600")}
      >
        <PlusIcon aria-hidden="true" className="-ml-0.5 h-5 w-5" />
        Factuur regel toevoegen
      </button>                    

                  </dt>
                  </div>

                  <div className=" block w-full mb-4 mt-10">
                  <dt className="font-semibold text-gray-900 px-4 pt-4 pb-4">
      <button
      disabled={(!selectedCustomer || invoice.rows.length == 0)}
        onClick={() => createInvoiceHandler(event)}
        type="button"
        className={"inline-flex items-center gap-x-1.5 rounded-md bg-green-600 px-2.5 py-1.5 text-sm font-semibold text-white shadow-sm block w-full "+ ((!selectedCustomer || invoice.rows.length == 0) ? "cursor-not-allowed opacity-50" : "hover:bg-green-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-600")}
      >
        <PlusIcon aria-hidden="true" className="-ml-0.5 h-5 w-5" />
        Factuur aanmaken
      </button>                    

                  </dt>
                  </div>

                  
              </dl>
              </div>
            </div>          
          
          
          

 

            {/* Invoice */}
            <div className="-mx-4 px-4 py-0 shadow-sm ring-1 ring-gray-900/5 sm:mx-0 sm:rounded-lg sm:px-8 sm:pb-14 lg:col-span-2 lg:row-span-2 lg:row-end-2 xl:px-16 xl:pb-20 xl:pt-16 relative">
              <h2 className="text-base font-semibold leading-6 text-gray-900">Nieuwe factuur</h2>
              <dl className="mt-6 grid grid-cols-1 text-sm leading-6 sm:grid-cols-2">
                <div className="mt-8 sm:mt-6 sm:border-t sm:border-gray-900/5 sm:pl-4 sm:pt-6">
                  <dd className="mt-2 text-gray-500">
                    <span className="font-medium text-gray-900">{(selectedCustomer) ? selectedCustomer.name : ""}</span>
                    <br />
                    {(selectedCustomer) ? selectedCustomer.addresses[0]["address"] : ""}
                    <br />
                    {(selectedCustomer) ? selectedCustomer.addresses[0]["zipcode"] : ""} {(selectedCustomer) ? selectedCustomer.addresses[0]["residence"] : ""}
                  </dd>
                </div>
                <div className="mt-6 border-t border-gray-900/5 pt-6 sm:pr-4">
                  <dd className="mt-2 text-gray-500">
                    <span className="font-medium text-gray-900">{props.data.from.name}</span>
                    <br />
                    {props.data.from.addresses[0]["address"]}
                    <br />
                    {props.data.from.addresses[0]["zipcode"]} {props.data.from.addresses[0]["residence"]}
                  </dd>
                </div>
              </dl>
              <table className="mt-16 w-full whitespace-nowrap text-left text-sm leading-6">
                <colgroup>
                  <col className="w-full" />
                  <col />
                  <col />
                  <col />
                </colgroup>
                <thead className="border-b border-gray-200 text-gray-900">
                  <tr>
                    <th scope="col" className="px-0 py-3 font-semibold">
                      Omschrijving
                    </th>
                    <th scope="col" className="hidden py-3 pl-8 pr-0 text-right font-semibold sm:table-cell">
                      Aantal
                    </th>
                    <th scope="col" className="hidden py-3 pl-8 pr-0 text-right font-semibold sm:table-cell">
                      Prijs 
                    </th>
                    <th scope="col" className="py-3 pl-8 pr-0 text-right font-semibold">
                      Totaal prijs
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {invoice && invoice.rows.map((item) => (
                    <tr key={uuid().slice(0, 8)} className="border-b border-gray-100">
              <td className="max-w-0 px-0 py-5 align-top">
              <div className="absolute inline-flex flex-row pl-1 left-0">
              <button
                 type="button"
                 onClick={(event) => editInvoiceRow(item)}
                 className="inline-flex items-center gap-x-.5 rounded-md  px-1.5 py-1.5 text-sm font-semibold text-white shadow-xs focus-visible:outline-2 focus-visible:outline-offset-2 text-gray-900 shadow-xs ring-1 ring-gray-300 ring-inset"
               >
                 <PencilIcon aria-hidden="true" className="-ml-0.5 size-4 fill-gray-500" />
               </button>
              </div>
                      
                        <div className="truncate font-medium text-gray-900">{item.title}</div>
                        <span className="truncate text-gray-500" dangerouslySetInnerHTML={{__html: item.description.replace(/\n/g, "<br />")}} />
                      </td>
                      <td className="hidden py-5 pl-8 pr-0 text-right align-top tabular-nums text-gray-700 sm:table-cell">
                        {item.amount}
                      </td>
                      <td className="hidden py-5 pl-8 pr-0 text-right align-top tabular-nums text-gray-700 sm:table-cell">
                        {Number(item.price).toFixed(2)}
                      </td>
                      <td className="py-5 pl-8 pr-0 text-right align-top tabular-nums text-gray-700">{Number(item.total_price).toFixed(2)}</td>
                    </tr>
                  ))}
                </tbody>
                <tfoot>
                  <tr>
                    <th scope="row" className="px-0 pb-0 pt-6 font-normal text-gray-700 sm:hidden">
                      Subtotaal
                    </th>
                    <th
                      scope="row"
                      colSpan={3}
                      className="hidden px-0 pb-0 pt-6 text-right font-normal text-gray-700 sm:table-cell"
                    >
                      Subtotaal
                    </th>
                    <td className="pb-0 pl-8 pr-0 pt-6 text-right tabular-nums text-gray-900">{invoice.subtotal.toFixed(2)}</td>
                  </tr>
                    {invoice.tax && Object.keys(invoice.tax).map((tax) => (
                        <>
                  <tr>
                    <th scope="row" className="pt-4 font-normal text-gray-700 sm:hidden">
                      Tax
                    </th>
                    <th
                      scope="row"
                      colSpan={3}
                      className="hidden pt-4 text-right font-normal text-gray-700 sm:table-cell"
                    >
                      {invoice.tax[tax]["label"]}
                    </th>
                    <td className="pb-0 pl-8 pr-0 pt-4 text-right tabular-nums text-gray-900">{invoice.tax[tax]["amount"].toFixed(2)}</td>
                  </tr>
                    </>
                    ))}
                  <tr>
                    <th scope="row" className="pt-4 font-semibold text-gray-900 sm:hidden">
                      Totaal
                    </th>
                    <th
                      scope="row"
                      colSpan={3}
                      className="hidden pt-4 text-right font-semibold text-gray-900 sm:table-cell"
                    >
                      Totaal
                    </th>
                    <td className="pb-0 pl-8 pr-0 pt-4 text-right font-semibold tabular-nums text-gray-900">
                      {invoice.invoice_total.toFixed(2)}
                    </td>
                  </tr>
                </tfoot>
              </table>
              
            </div>

            <div className="lg:col-start-3">
 
  
            </div>
          </div>
        </div>
      </main>     
     
     
     
    </div>
    }
    </>
    );
}